export default "__VITE_ASSET__DJwZdLQn__"